import React from "react";

// Define the possible status types
export type UpdateStatus = "edit" | "preview" | "prepare" | "sent";

interface StatusPillProps {
  status: UpdateStatus;
}

// Mapping of status to colors for the pill
const statusStyles: Record<UpdateStatus, { bgColor: string; textColor: string }> = {
  edit: { bgColor: "bg-gray-300", textColor: "text-gray-700" },
  preview: { bgColor: "bg-blue-300", textColor: "text-blue-700" },
  prepare: { bgColor: "bg-yellow-300", textColor: "text-yellow-900" },
  sent: { bgColor: "bg-green-300", textColor: "text-green-900" },
};

const statusLabels: Record<UpdateStatus, string> = {
  edit: "Editing",
  preview: "Previewing",
  prepare: "Preparing",
  sent: "Sent",
};

const StatusPill: React.FC<StatusPillProps> = ({ status }) => {
  const styles = statusStyles[status];

  // Map to display version (e.g., "edit" -> "Editing")
  const label = statusLabels[status];

  return (
    <span
      className={`inline-block px-3 py-1 rounded-full text-sm font-semibold ${styles.bgColor} ${styles.textColor} select-none`}
      aria-label={`Status: ${label}`}
    >
      {label}
    </span>
  );
};

export default StatusPill;
